<template>
    <div>
        <div id="tg-placeholder"></div>
        <div class="loading loading--primary" v-if="loading">
            <div class="loading__inner">
                <div class="loading__spinner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    data: () => ({
        loading: false,
    }),

    mounted() {
        var vm = this;

        if (!window.website.protecht_public_key) {
            return;
        }

        if (this.order && this.order.id) {
            this.$nextTick(function () {
                if(window.tg) {
                    // destroy purges the previous instance, and even removes the script tag
                    window.tg.destroy();
                }

                // (re)create script tag
                (function(w,d,c,n,s,p){
                    w[n] = w[n] || function () { (w[n].q = w[n].q || []).push(arguments) }, w[n].l = +new Date();
                    s = d.createElement(c), p = d.getElementsByTagName(c)[0];
                    s.async = s.src = 'https://icw.protecht.com/client-widget.min.js';
                    p.parentNode.insertBefore(s, p);
                })(window,document,'script','tg');

                var itemsCosts = vm.order.lines
                    .map((line) => {
                        return line && line.price_with_booking_fee
                            ? line.price_with_booking_fee.toString()
                            : null;
                    })
                    .filter((cost) => cost);

                window.tg("configure", {
                    apiKey: window.website.protecht_public_key,
                    locale: "en_US",
                    currency: window.currency.code,
                    sandbox: window.website.env == "local",
                    costsOfItems: itemsCosts,
                    loadedCb: function () {
                        // var quoteToken = tg.get("token");
                        // var coverageQuote = tg.get("quote");
                        // vm.optInChanged(quoteToken, coverageQuote, false);
                    },
                    optInCb: function () {
                        var quoteToken = tg.get("token");
                        var coverageQuote = tg.get("quote");
                        vm.optInChanged(quoteToken, coverageQuote, true);
                    },
                    optOutCb: function () {
                        var quoteToken = tg.get("token");
                        var coverageQuote = tg.get("quote");
                        vm.optInChanged(quoteToken, coverageQuote, false);
                    },
                });
            });
        }
    },
    methods: {
        optInChanged(quoteToken, cost, optedIn) {
            // this.$emit('loading', true);
            // this.loading = true;
            axios
                .post("/checkout/protecht", {
                    token: quoteToken,
                    cost: cost,
                    opted_in: optedIn,
                })
                .then((response) => {
                    // this.loading = false;
                    this.$emit("order-updated");
                })
                .catch((error) => {
                    // this.$emit("loading", false);
                    // this.loading = false;
                    this.errors = error.response.data.errors;
                });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Checkout/protecht/ProtechtWidget.vue